/**
 * Schema.org Components - Main Exports
 * Consolidated export file for all schema components and data
 */

// Re-export everything from SchemaMarkup for backward compatibility
export * from './SchemaMarkup';

// Re-export types
export type {
  BreadcrumbItem,
  LodgeSchemaProps,
  AdventureSchemaProps,
  FAQItem,
  ReviewSchemaProps,
  TestimonialReview,
  HowToStep,
  HowToSchemaProps,
  EventSchemaProps,
} from './types';

// Re-export utils
export { parseReviewDate, parseEventDate } from './utils';

// Re-export components (these override the SchemaMarkup exports with modular versions)
export { OrganizationSchema, WebsiteSchema } from './organization';
export { BreadcrumbSchema } from './breadcrumb';
export { LodgeSchema } from './lodge';
export { AdventureSchema } from './adventure';
export { FAQSchema, GlobalFAQSchema } from './faq';
export { LocalBusinessSchema } from './business';
export { ReviewSchema, AggregateRatingSchema, TestimonialsPageSchema } from './review';
export { EventSchema, EventsListSchema } from './event';
export { HowToSchema } from './howto';

// Re-export data
export { GLOBAL_FAQS } from './data/global-faqs';
